import { IDCodesLookupLayout, IDMasterLookupLayout ,IDShipViaLookupLayout,IDParticipantLookupLayout,IDTaxHeaderLookupLayout ,IDWarehouseLookupLayout,
    IDContactLookupLayout,IDProfileLookupLayout,IDExceptionCodeLookupLayout,IDWeekSettingsLookupLayout} from "../../../../common/lookups/Layouts/IdLayouts"

const PrimaryLayout = [
    {
        "groupId": 1,
        "label": "",
        "fields": [
            {
                "name": "R_PROFILE",
                "tableName": "IDMASTER",
                "label": "Profile",
                "type": "lookup",
                "layout":IDProfileLookupLayout,
                "required": true,
                "visible": true,
                "isLabelChanged": false,
            } ,
            {
                "name": "IDENTITYID",
                "tableName": "IDMASTER",
                "label": "Identity ID",
                "type": "text",
                "required": true,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    } ,{
        "groupId": 2,
        "label": "",
        "fields": [
            {
                "name": "CustomerR_TERMS",
                "localizedField": "R_TERMS",
                "tableName": "IDCUSTOMER",
                "label": "Terms",
                "type": "select",
                "required": true,
                "visible": true,
                "isLabelChanged": false,
            },{
                "name": "CustomerARACCOUNT",
                "localizedField": "ARACCOUNT",
                "tableName": "IDCUSTOMER",
                "label": "AR Account",
                "type": "select",
                "required": true,
                "visible": true,
                "isLabelChanged": false,
            }
             
        ]
    } 
]
 
export {
    PrimaryLayout,
  
}